export default "__VITE_ASSET__f7dfaf61__"